import { AudioInputState, AudioInputStateNull } from "@/types/defs/audioInput";

export const isAudioInputNull = (
  audioInput: AudioInputState
): audioInput is AudioInputStateNull => {
  const selectedFileCover = audioInput.selectedFileCover;
  return selectedFileCover === null;
};
